import React from "react";
import { graphql, Link, PageProps, useStaticQuery } from "gatsby";

import Layout from "../components/Layout";
import SEO from "../components/Seo";
import PageTitle from "../components/PageTitle";
import Typography from "@material-ui/core/Typography";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import moment from "moment";
import clsx from "clsx";
import { yellow } from "@material-ui/core/colors";

interface BlogQuery {
    allMdxBlogPost: {
        nodes: BlogNode[];
    };
}

interface BlogGroup {
    [key: string]: BlogNode[];
}

interface BlogNode {
    title: string;
    slug: string;
    description: string;
    timestamp: number;
    year: number;
    date: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        rowItem: {
            display: "flex",
            marginBottom: 8,
        },
        rowItemDate: {
            minWidth: 135,
            marginRight: 20,
            fontWeight: 500,
        },
        rowItemPreview: {
            fontWeight: 700,
            backgroundColor: yellow[500],
        },
        rowItemLink: {
            flexGrow: 1,
        },
        list: {
            paddingBottom: theme.spacing(4),
            paddingTop: theme.spacing(4),
        },
    })
);

interface BlogPostListProps {
    all?: boolean;
}

const BlogPostList: React.FC<BlogPostListProps> = (props) => {
    const classes = useStyles();
    const ts = +moment().subtract(10, "h").format("X");
    const filter_ts = props.all ? Number.MAX_VALUE : ts;
    const data = useStaticQuery<BlogQuery>(
        graphql`
            {
                allMdxBlogPost(sort: { fields: timestamp, order: DESC }) {
                    nodes {
                        title
                        slug
                        timestamp
                        year
                        date(formatString: "MMMM D")
                    }
                }
            }
        `
    );

    const nodes = data.allMdxBlogPost.nodes.filter(
        (node) => node.timestamp < filter_ts
    );

    const groups = nodes.reduce((result: BlogGroup, item) => {
        const year = item.year.toString();
        return {
            ...result,
            [year]: [...(result[year] || []), item],
        };
    }, {});

    const groupKeys = Object.keys(groups).sort((a, b) => Number(b) - Number(a));

    return (
        <div className={classes.list}>
            {groupKeys.map((key) => (
                <div key={key}>
                    <h2>{key}</h2>
                    {groups[key].map((node) => {
                        return (
                            <div key={node.slug} className={classes.rowItem}>
                                <div className={classes.rowItemDate}>
                                    <span
                                        className={clsx(
                                            node.timestamp > ts &&
                                                classes.rowItemPreview
                                        )}
                                    >
                                        {node.date}
                                    </span>
                                </div>
                                <div className={classes.rowItemLink}>
                                    <Link to={node.slug}>{node.title}</Link>
                                </div>
                            </div>
                        );
                    })}
                </div>
            ))}
        </div>
    );
};

export default BlogPostList;
